<div class="u-height-100 u-padding-24" fxLayout="column">
  <div class="u-marginBottom-8" fxFlex="100%">
    <p class="text-body-2" i18n="@@populateSegmentValuesDrawer.subtitle">
      Review values before adding them to the Hub. 10KC values with matching
      words will be mapped automatically.
    </p>
    <mat-form-field
      class="mat-form-field-width-100 mat-form-field-height-100 u-marginTop-16"
    >
      <textarea
        [formControl]="segmentValuesToDisplay"
        [readonly]="true"
        aria-label="Segment values"
        i18n-aria-label="@@populateSegmentValuesDrawer.inputLabel"
        autocomplete="off"
        cdkTextareaAutosize
        matInput
      ></textarea>
    </mat-form-field>
    <p
      class="color-text-subdued text-body-md"
      i18n="@@populateSegmentValuesDrawer.hint"
    >
      Duplicate items will not be added again.
    </p>
  </div>
  <div
    class="u-paddingTop-16 u-borderTop-grey100"
    fxFlex="0 0 auto"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <p
      i18n="@@populateSegmentValuesDrawer.valuesCounterText"
      class="color-text-subdued text-body-md"
    >
      {{ segmentValues.length }} values will be added
    </p>
    <div fxFlex="0 0 auto" fxLayoutAlign="end center" fxLayoutGap="16px">
      <button (click)="closeDrawer()" mat-button i18n="@@global.cancel">
        Cancel
      </button>
      <button
        [disabled]="isLoading || 0 === segmentValues.length"
        (click)="addValues()"
        color="primary"
        mat-raised-button
        type="button"
      >
        <span
          class="text-body-md"
          i18n="@@populateSegmentValueDrawer.addValuesButtonText"
        >
          Add and map values
        </span>
        @if (isLoading) {
          <i class="u-marginLeft-8" nz-icon nzSpin nzType="sync"></i>
        }
      </button>
    </div>
  </div>
</div>
